import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EProductTemplatesListItem } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-list-item';

@Component({
  selector: 'gd-product-templates-list',
  templateUrl: './product-templates-list.component.html',
  styleUrls: ['./product-templates-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTemplatesListComponent {
  @Input() items: EProductTemplatesListItem[];
  @Input() showPlaceOrderButton = true;
  @Input() columns: 'four' | 'three' = 'four';
  @Input() showEditButton = true;
  @Input() showActionButtons = true;
  @Input() infiniteScrollContainer = '.layout-content';
  @Output() placeOrderButtonClick = new EventEmitter<EProductTemplatesListItem>();
  @Output() addToStoreButtonClick = new EventEmitter<EProductTemplatesListItem>();
  @Output() editButtonClick = new EventEmitter<EProductTemplatesListItem>();
  @Output() renameButtonClick = new EventEmitter<EProductTemplatesListItem>();
  @Output() duplicateButtonClick = new EventEmitter<EProductTemplatesListItem>();
  @Output() deleteButtonClick = new EventEmitter<EProductTemplatesListItem>();
  @Output() itemClick = new EventEmitter<EProductTemplatesListItem>();
  @Output() scrollDown = new EventEmitter<void>();

  get containerClasses(): string {
    return `ui ${this.columns} column doubling stackable grid`;
  }

  onPlaceOrderButtonClick(item: EProductTemplatesListItem) {
    this.placeOrderButtonClick.emit(item);
  }

  onAddToStoreButtonClick(item: EProductTemplatesListItem) {
    this.addToStoreButtonClick.emit(item);
  }

  onEditButtonClick(item: EProductTemplatesListItem) {
    this.editButtonClick.emit(item);
  }

  onRenameButtonClick(item: EProductTemplatesListItem) {
    this.renameButtonClick.emit(item);
  }

  onDuplicateButtonClick(item: EProductTemplatesListItem) {
    this.duplicateButtonClick.emit(item);
  }

  onDeleteButtonClick(item: EProductTemplatesListItem) {
    this.deleteButtonClick.emit(item);
  }

  onScrollDown() {
    this.scrollDown.emit();
  }
}
